module.exports = __webpack_public_path__ + "media/tonoMensaje.fb742daa.mp3";